import { render, staticRenderFns } from "./safetyOperGuideBookEditor.vue?vue&type=template&id=4c5ee0c0"
import script from "./safetyOperGuideBookEditor.vue?vue&type=script&lang=js"
export * from "./safetyOperGuideBookEditor.vue?vue&type=script&lang=js"
import style0 from "./safetyOperGuideBookEditor.vue?vue&type=style&index=0&id=4c5ee0c0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c5ee0c0')) {
      api.createRecord('4c5ee0c0', component.options)
    } else {
      api.reload('4c5ee0c0', component.options)
    }
    module.hot.accept("./safetyOperGuideBookEditor.vue?vue&type=template&id=4c5ee0c0", function () {
      api.rerender('4c5ee0c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/opm/safetyOperGuideBookEditor.vue"
export default component.exports